var chunkMapping = {
	"90": [
		63852,
		65613
	]
};
var idToExternalAndNameMapping = {
	"63852": [
		"default",
		".",
		30388
	],
	"65613": [
		"default",
		".",
		9467
	]
};
var idToRemoteMap = {
	"63852": [
		{
			"externalType": "script",
			"name": "shipbob_mfe_runtime"
		}
	],
	"65613": [
		{
			"externalType": "script",
			"name": "shipbob_design_system"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"63852": {
		"shareScope": "default",
		"name": ".",
		"externalModuleId": 30388,
		"remoteName": "shipbob_mfe_runtime"
	},
	"65613": {
		"shareScope": "default",
		"name": ".",
		"externalModuleId": 9467,
		"remoteName": "shipbob_design_system"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}